
import Vue from 'vue'

const getDefaultState = () => {
    return {
        orders: {
            id: 0,
            idServiceProject: 0,
            idProduct: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async OrdersList(_, orderRequestFilter) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`warehouse/orders-list`, orderRequestFilter,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listOrder = result.data.result;

                return listOrder;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list order: [${ex}]`
            };
        }
    },

    async OrdersGetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`warehouse/orders/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get order`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get order: [${ex}]`
            };
        }
    },

    async OrdersCreateUpdate(_, orderRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`warehouse/orders/create-update`, orderRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (orderRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async CheckWarehouseOrders(_, orderRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`warehouse/orders/check-warehouse-orders`, orderRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (orderRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to check ware house project register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to check ware house project register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to check ware house project register: [${error}]`
                };
            }
        }
    },

    async OrdersUpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`warehouse/orders/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },

    async OrdersListHistory(_, idOrder) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`warehouse/orders/list-history/${idOrder}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listHistory = result.data.result;

                return listHistory;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list order history: [${ex}]`
            };
        }
    },
    
    async ListOrderStatus() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`warehouse/orders/list-status`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listStatus = result.data.result;

                return listStatus;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list orders status: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.orders, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.orders;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}